import { CSSObject } from "@emotion/react";
import { constants, typographyStyles } from "@newsela/angelou";

const { ui } = constants.colors;
const { fontSize } = typographyStyles;

export const lessonPlanEditorBodyStyles: CSSObject = {
  // Prevent scroll on lesson planner editor
  '.tiptap.ProseMirror[contenteditable="true"]': {
    maxHeight: "none !important",
  },
};

export const commonButtonCss = {
  root: {
    display: "inline-block",
  },
  Icon: {
    root: {
      marginLeft: "0.5rem",
      verticalAlign: "bottom",
    },
  },
};

export const bottomEditActionButtonsCss: CSSObject = {
  display: "flex",
  justifyContent: "end",
  gap: "16px",
  borderTop: `1px solid ${ui.neutral[100]}`,
  padding: "1em 0",
};

export const collapseActionsWrapperCss: CSSObject = {
  display: "flex",
  justifyContent: "space-between",
  paddingBottom: "1rem",
  gap: "16px",
  "& > div": {
    width: "100%",
  },
};

export const bottomWarningCss: CSSObject = {
  ...fontSize.textS,
  color: ui.neutral[500],
  borderTop: `1px solid ${ui.neutral[100]}`,
  paddingTop: "1em",
};
